"use client";

import { useStore } from '@/stores';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure
} from '@nextui-org/react';
import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';

function InTestingProcessModal() {
  // Access store directly without the persist wrapper
  const isTestingProcessModalShown = useStore((state) => state.isTestingProcessModalShown);
  const setIsTestingProcessModalShown = useStore((state) => state.setIsTestingProcessModalShown);

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const [secondsLeft, setSecondsLeft] = useState(5);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isDomainVn, setIsDomainVn] = useState(false);

  useEffect(() => {
    // Wait for hydration to complete
    if (typeof window !== 'undefined') {
      // Check if domain contains ".vn"
      const hostname = window.location.hostname;
      const isVnDomain = hostname.endsWith('.vn') || hostname.includes('.vn');
      setIsDomainVn(isVnDomain);

      // Set initialization flag after a small delay to ensure store is hydrated
      const initTimer = setTimeout(() => {
        setIsInitialized(true);
      }, 100);

      return () => clearTimeout(initTimer);
    }
  }, []);

  useEffect(() => {
    // Only proceed if:
    // 1. We're initialized
    // 2. The modal hasn't been shown before
    // 3. We're on a .vn domain
    if (isInitialized && isTestingProcessModalShown === false && isDomainVn) {
      onOpen();

      // Set up countdown timer
      const timer = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            onClose();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Set a timeout to close the modal after 5 seconds
      const closeTimer = setTimeout(() => {
        onClose();
        // Mark as shown after closing
        setIsTestingProcessModalShown(true);
      }, 5000);

      // Clean up the timers when component unmounts
      return () => {
        clearInterval(timer);
        clearTimeout(closeTimer);
      };
    }
    return () => { }
  }, [isInitialized, isTestingProcessModalShown, isDomainVn, setIsTestingProcessModalShown, onOpen, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      size="2xl"
      placement="center"
      classNames={{
        base: "rounded-2xl",
      }}
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader className="flex flex-col items-center gap-1">
              <div className="flex items-center justify-center">
                <Info className="w-4 h-4 mr-1 text-neutral-500" />
                <span className='text-md font-light'>Thông báo</span>
              </div>
            </ModalHeader>
            <ModalBody className="pb-6">
              <p className="text-center text-lg">
                Website đang hoạt động thử nghiệm và đang trong quá trình đăng ký Bộ Công Thương
              </p>
              <p className="text-center text-gray-600 mt-5">
                Sẽ đóng sau {secondsLeft}s
              </p>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

export default InTestingProcessModal;
